"use strict";

new Vue({
  mixins: [main],
  data: function data() {
    return {
      post: undefined,
      id: apiId,
      relationItems: [],
      preview: preview,
      loading: true
    };
  },
  methods: {
    setSeoSetting: function setSeoSetting(post) {
      $('title').text(post.title + 'の入荷情報 | らしんばん');
      $('meta[name="description"]').attr('content', post.title + 'の入荷情報です。フィギュア・アクスタ・ぬいぐるみ・缶バッジ・ラバスト・キーホルダー・DVDなど中古アニメグッズの買取・販売のらしんばん！ゲーム、CD、コミック、書籍、同人誌まで幅広いラインナップで売りたい・買いたいアイテムが見つかるらしんばんをぜひご利用ください！');

      if (post.thumbnail) {
        $('meta[property="og:image"], meta[name="twitter:image"]').attr('content', olineImgUrl + '/' + post.thumbnail);
      }

      if (post.r18_flag) {
        $('meta[property="og:image"], meta[name="twitter:image"]').attr('content', templateDirectoryUri + '/img/r18_ogp.png');
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    axios.get(apiUrl + '/api/get_arrival', {
      params: {
        id: this.id,
        number: 1,
        preview: this.preview
      }
    }).then(function (response) {
      if (!response.data.items[0]) {
        _this.readySingle(_this.post, true);

        _this.loading = false;
        return;
      }

      _this.post = response.data.items[0];
      axios.get(apiUrl + '/api/get_arrival', {
        params: {
          store: _this.post ? _this.post.store[0].id : undefined,
          number: 4
        }
      }).then(function (response) {
        _this.relationItems = response.data.items.map(function (item) {
          return {
            title: item.title,
            img: item.thumbnail ? olineImgUrl + '/' + item.thumbnail : templateDirectoryUri + '/img/no_image_arrival.jpg',
            date: item.date,
            store: item.store.map(function (store) {
              return store.name;
            }),
            url: '/arrival/' + item.id + '/',
            r18Flag: item.r18_flag
          };
        });

        _this.readySingle(_this.post);

        _this.loading = false;
      });
    });
  }
});